module.exports = __webpack_public_path__ + "static/9-Badminton-Court-d19d19c87004891d14af6b9c72268f31.jpg";